
import React from 'react';
import CTAButton from '@/components/CTAButton';
import { Link } from 'react-router-dom';
import { useBreakpoint } from '@/hooks/use-mobile';

const CallToAction = () => {
  const { isMobile } = useBreakpoint();

  return (
    <div className="w-full px-0 py-8 md:py-10 border-y border-gray-100 bg-[#FEE6D8] rounded-lg">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
          <div className="w-full md:w-auto">
            <h3 className="text-xl md:text-2xl font-bold text-[#003a70] mb-2 md:mb-1">
              Ready to get started?
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Create your first AI assistant or form today.
            </p>
          </div>
          
          <CTAButton to="/pricing" variant="primary">
            <span className="font-medium">Start Free Trial</span>
            <span className="transform transition-transform group-hover:translate-x-1">→</span>
          </CTAButton>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
